import tenantData from '@data';
import tenantUtils from '@utils';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LoaderWrapper, notification } from '../../components/common';
import { strings } from '../../constants/strings';
import Algolia from '../../services/algolia';
import { JSONFormStyled } from '../common/json-form/styled';
import { Modal } from '../common/modals/antd-modals';
import {
  useAddAgencyStaffUserMutation,
  useGetAgencyUserDetailsQuery,
  useUpdateAgencyUserMutation,
} from '../../apis/agency';
import { confirmEditStaffClickEvent } from '../../services/analyticsService';
import { useSelector } from 'react-redux';
export const UserForm = ({ isVisible, setIsVisible, agencyId, userId, isAdmin }) => {
  const { t } = useTranslation();
  const [cities, setCities] = useState(false);
  const formRef = useRef();
  const { user } = useSelector((state) => state.app.loginUser);
  const {
    data: formData,
    isFetching,
    isLoading,
    error,
    refetch,
  } = useGetAgencyUserDetailsQuery(userId, { skip: !isVisible || !userId, refetchOnMountOrArgChange: true });

  const [updateUser, { isLoading: updating }] = useUpdateAgencyUserMutation();
  const [addUser, { isLoading: addingUser }] = useAddAgencyStaffUserMutation();
  const userImageGuidelines = [
    { key: 1, label: 'Upload a front-facing picture of yourself with a solid background.' },
    { key: 2, label: 'Pictures of logos, buildings, or irrelevant images are not allowed.' },
  ]

  useEffect(() => {
    fetchCities();
  }, []);

  const fetchCities = async (text) => {
    let queryObject = null;
    if (!!text) {
      queryObject = Algolia.getCitiesByName(text);
    } else {
      queryObject = Algolia.getAllCities();
    }
    const response = await Algolia.getLocationsIndex().search('', queryObject);

    setCities(
      response.hits.map((e) => {
        return { id: e.location_id, name: tenantUtils.getLocalisedString(e, 'title') };
      }),
    );
  };
  const fields = useMemo(
    () => tenantData.agencyStaffUserFormFields(formData, cities, fetchCities, userImageGuidelines),
    [tenantData, formData, cities],
  );

  const onCloseModal = () => {
    setIsVisible(false);
    formRef?.current && formRef?.current?.resetForm();
  };

  const handleOk = () => {
    formRef.current && formRef.current.submitForm();
  };

  const handleDetailsSubmit = async (values) => {
    const response = userId ? await updateUser({ userId, agencyId, values }) : await addUser({ agencyId, ...values });
    confirmEditStaffClickEvent(user, values, response?.error);
    if (response.error) {
      notification.error(response.error);
    } else {
      onCloseModal();
    }
  };

  return (
    <Modal
      type="primary"
      title={userId ? t(strings.edit_user) : t(strings.add_user)}
      visible={isVisible}
      okText="Confirm"
      okButtonProps={{ type: 'primary' }}
      loading={isLoading || updating || addingUser}
      onOk={handleOk}
      onCancel={onCloseModal}
      width={990}
    >
      <LoaderWrapper loading={isFetching && !isLoading}>
        <JSONFormStyled
          fields={fields}
          formFieldValues={formData}
          ref={formRef}
          onSubmitForm={handleDetailsSubmit}
          loading={isLoading}
          fetchError={error}
          retryButtonLoading={!formData && isLoading}
          onRetry={refetch}
          noOfContentColumns={2}
        />
      </LoaderWrapper>
    </Modal>
  );
};
